const options = {
  5: "bg-cyan-800/5",
  10: "bg-cyan-800/10",
  25: "bg-cyan-800/25",
  50: "bg-cyan-800/50",
  75: "bg-cyan-800/75",
  90: "bg-cyan-800/90",
  100: "bg-cyan-800",
};

const from = {
  5: "from-cyan-800/5",
  10: "from-cyan-800/10",
  25: "from-cyan-800/25",
  50: "from-cyan-800/50",
  75: "from-cyan-800/75",
  90: "from-cyan-800/90",
  100: "from-cyan-800",
};

export default function getBackgroundCyan800(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
